import styled from "styled-components";
import { primaryColor } from "../../../../../config/constants";

export const MainDiv = styled.div`
  margin: 20px auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  transition: all 0.5s ease-in-out;
  @media (max-width: 910px) {
    width: 85%;
    padding: 10px;
  }
`;
export const PositionerLevelsDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: 490px) {
    flex-direction: column;
    justify-content: center;
  }
`;
export const LevelsDiv = styled.div`
  padding: 20px 20px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const LevelButton = styled.button`
  padding: 0 10px;
  font-size: 12px;
  font-weight: ${({ active }) => active && "bold"};
  color: ${({ active }) => (active ? "#808080" : primaryColor)};
  border: none;
  border-left: ${({ borderLeft }) => (borderLeft ? "1px solid #e6e6e6" : "none")};
  outline: none;
  background: transparent;
  cursor: pointer;
  @media (max-width: 490px) {
    font-size: 12px;
  }
`;
